$(function () {
    let latest_news_url = $("#latest-news-url").val();
    let locale = $("#locale").val();
    let articles = $("#article-url").val();
    if (latest_news_url) {
        $.ajax({
            type: "POST",
            url: latest_news_url,
            data: {
                locale: locale,
            },
            success: function (data) {
                let latestPages = data.latestPages;
                let box = document.getElementById("element-box");

                latestPages.forEach((el) => {
                    let a = document.createElement("a");
                    a.className = "related-content-tile";
                    a.setAttribute("href", el.url);
                    let div_img = document.createElement("div");
                    div_img.className = "related-content-img-w";
                    let img = document.createElement("img");
                    img.className = "ls-is-cached lazyloaded";
                    img.setAttribute("data-src", el.image);
                    img.setAttribute("src", el.image);

                    div_img.append(img);
                    a.append(div_img);

                    let div_title = document.createElement("div");
                    div_title.className = "related-content-tile-meta";
                    let ul = document.createElement("ul");
                    let li_span = document.createElement("li");
                    let span = document.createElement("span");
                    span.innerHTML = el.date.date.substring(0, 10);
                    let li_h3 = document.createElement("li");
                    let h3 = document.createElement("h3");
                    h3.innerHTML = el.title;

                    li_span.append(span);
                    ul.append(li_span);

                    li_h3.append(h3);
                    ul.append(li_h3);

                    div_title.append(ul);
                    a.append(div_title);

                    box.append(a);
                });
                let all_articles = document.createElement("div");
                let locale = $("#locale").val();
                let see_all_articles_text = "";
                switch (locale) {
                    case "en":
                        see_all_articles_text = "See All Articles";
                        break;
                    case "ja":
                        see_all_articles_text = "すべての記事を見る";
                        break;
                    case "zh-CN":
                        see_all_articles_text = "查看全部相关文章（English）";
                        break;

                    default:
                        title = property["title"];
                        break;
                }
                all_articles.className = "controls-below-table text-center";
                all_articles.innerHTML =
                    '<a href="' +
                    articles +
                    '" class="btn btn-outline-primary no-bottom-border">' +
                    see_all_articles_text +
                    "</a>";
                box.append(all_articles);
            },
            error: function (error) {},
        });
    }
});
